/**
 * View Component: ManualBanner
 * Prominent entry card at the very top of the main feed.
 * Links to the operations manual (Feishu doc, opens in a new tab).
 *
 * Props:
 *   url: string — manual document URL
 */

function ManualBanner({ url }) {
  return (
    <a
      className="manual-banner"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="打开小红书运营操作手册（飞书文档，新窗口）"
    >
      <span className="manual-banner-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="M12 3l7 2.6v5.2c0 4.5-3 8-7 10-4-2-7-5.5-7-10V5.6L12 3z"></path>
          <path d="M9 11.6l2.1 2.1L15.3 9.5"></path>
        </svg>
      </span>
      <span className="manual-banner-text">
        <span className="manual-banner-title-row">
          <span className="manual-banner-title">小红书运营操作手册</span>
          <span className="manual-banner-badge">飞书文档</span>
        </span>
        <span className="manual-banner-subtitle">限流规避与流量增长 · 30条快查清单</span>
      </span>
      <span className="manual-banner-btn" aria-hidden="true">
        打开手册
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="M5 12h13"></path>
          <path d="M13 6l6 6-6 6"></path>
        </svg>
      </span>
    </a>
  );
}

window.ManualBanner = ManualBanner;

export default ManualBanner;
